import { Auth } from 'aws-amplify';

const currentSessionIdToken = async () => (await Auth.currentSession())
  .getIdToken()
  .getJwtToken();

export default currentSessionIdToken;
